import ArrowDown from '@mdi/svg/svg/arrow-down-thin.svg?react';
import ArrowUp from '@mdi/svg/svg/arrow-up-thin.svg?react';
import React from 'react';
import { Flex } from '../Flex';
import { MDIIcon } from '../MDIIcon';
import {
  Table,
  TableBody,
  TableCell,
  TableCellHeader,
  TableContainer,
  TableHead,
  TableRow,
} from './Table';
import TableFilter from './TableFilter';
import TablePagination from './TablePagination';
import { type BasicTableProps } from './types';

/*
 * This component is a basic table that accepts headers, rows, and footers as props
 * and renders a table with the given data. It makes use of the Table building blocks
 */
export const BasicTable: React.FC<BasicTableProps> = ({
  headers,
  rows,
  pagination,
  tableFilterLocalizations,
}) => {
  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableCellHeader key={header.id} active={!!header.isSorted} width={header.width}>
                  <Flex alignItems="center" gap="0.5rem">
                    <Flex alignItems="center" gap="0.5rem" onClick={header.onClick} width="auto">
                      <span>{header.content}</span>
                      {header.isSorted && (
                        <MDIIcon size={18} icon={header.isSorted === 'asc' ? ArrowUp : ArrowDown} />
                      )}
                    </Flex>
                    {!!header.meta?.filterVariant &&
                      !!header.setFilterValue &&
                      (header.meta.filterVariant === 'select' ? (
                        <TableFilter
                          filterVariant={header.meta.filterVariant}
                          filterOptions={header.meta?.filterOptions}
                          filterValue={header.filterValue}
                          setFilterValue={header.setFilterValue}
                          localizations={tableFilterLocalizations}
                        />
                      ) : (
                        <TableFilter
                          filterVariant={header.meta.filterVariant}
                          filterValue={header.filterValue}
                          setFilterValue={header.setFilterValue}
                          localizations={tableFilterLocalizations}
                        />
                      ))}
                  </Flex>
                </TableCellHeader>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                {row.cells.map((cell) => (
                  <TableCell key={cell.id} active={cell.active}>
                    {cell.content}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && <TablePagination {...pagination} />}
    </>
  );
};
